<template>
  <Dialog
    :visible="modelValue"
    @update:visible="$emit('update:modelValue', $event)"
    header="Crea rappresentante"
    modal
    class="cambio-rappresentante-dialog"
    :style="{ width: 'min(92vw, 1000px)', height: '90vh', maxHeight: '90vh' }"
    :contentStyle="{ flex: '1 1 auto', overflowY: 'auto', display: 'flex', paddingTop: 0, paddingBottom: '0.25rem', background: 'var(--surface-50)' }"
  >
    <CreaRappresentanteForm
      v-if="modelValue"
      :modelValue="modelValue"
      :available="available"
      :initialIdentifier="initialIdentifier"
      @update:modelValue="$emit('update:modelValue', $event)"
      @created="$emit('created', $event)"
    />
  </Dialog>
</template>

<script>
import Dialog from 'primevue/dialog'
import CreaRappresentanteForm from '@/components/form/CreaRappresentanteForm.vue'

export default {
  components: { Dialog, CreaRappresentanteForm },
  props: {
    modelValue: Boolean,
    available: Boolean,
    initialIdentifier: { type: String, default: '' }
  },
  emits: ['update:modelValue', 'created']
}
</script>
